import { render, staticRenderFns } from "./UserWelcome.vue?vue&type=template&id=011e2929&scoped=true&"
import script from "./UserWelcome.vue?vue&type=script&lang=ts&"
export * from "./UserWelcome.vue?vue&type=script&lang=ts&"
import style0 from "./UserWelcome.vue?vue&type=style&index=0&id=011e2929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011e2929",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('011e2929', component.options)
    } else {
      api.reload('011e2929', component.options)
    }
    module.hot.accept("./UserWelcome.vue?vue&type=template&id=011e2929&scoped=true&", function () {
      api.rerender('011e2929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/nux/UserWelcome.vue"
export default component.exports